__turbopack_context__.v({
  "arrow": "promo-info-panel-module-sass-module__5yC3jG__arrow",
  "info": "promo-info-panel-module-sass-module__5yC3jG__info",
  "infoContent": "promo-info-panel-module-sass-module__5yC3jG__infoContent",
  "infoHeader": "promo-info-panel-module-sass-module__5yC3jG__infoHeader",
  "numeric": "promo-info-panel-module-sass-module__5yC3jG__numeric",
  "opened": "promo-info-panel-module-sass-module__5yC3jG__opened",
});
